import React, {Component} from 'react'
import FJInput from './FJInput'
import './FJNameInput.less'

class FJNameInput extends Component {

  errorAnimation = () => {
    this.input.errorAnimation();
  };

  isInputNone = () => {
    return this.input.isInputNone();
  };

  getValue = () => {
    return this.input.getValue();
  };

  render() {
    let {value, onChange, onSubmit, style, placeholder, hasError, errorValue, onFocus} = this.props;
    return <FJInput placeholder={placeholder}
                    ref={ele => this.input = ele}
                    className='c-project-name-input'
                    style={style}
                    hasError={hasError}
                    errorValue={errorValue}
                    value={value}
                    onChange={onChange}
                    onSubmit={onSubmit}
                    onFocus={onFocus}
                    hasIcon
    />
  }
}

export default FJNameInput